angular.module('shared').directive('switch', function() {
  return {
    restrict: 'E',
    template: require('templates/shared/switch.html.slim'),
    scope: {
      ngModel: '=',
      ngChange: '&',
      disabled: '=',
      inverse: '='
    },
    controller: ["$scope", "$timeout", function($scope, $timeout) {
      $scope.id = Math.floor(Math.random() * 10000);
      $scope.isChecked = function() {
        if ($scope.inverse) {
          return !$scope.ngModel;
        } else {
          return $scope.ngModel;
        }
      };
      return $scope.onChange = function() {
        return $timeout(function() {
          return $scope.ngChange();
        });
      };
    }]
  };
});
